import React from 'react';
import styled from 'styled-components';

interface TableProps {
  columns: string[];
  data: any[][];
}

interface StyledTableProps {
  width: string;
}

const TableContainer = styled.div`
  max-width: 80%;
  margin: 20px auto;
  overflow-y: auto;
  max-height: 400px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: white;
`;

const StyledTable = styled.table<StyledTableProps>`
  width: ${(props: StyledTableProps) => props.width};
  border-collapse: collapse;
`;

const Th = styled.th`
  padding: 12px;
  text-align: left;
  background: linear-gradient(to bottom, #6A89A6, #4F728F);
  color: white;
  position: sticky;
  top: 0;
  z-index: 2;
  border-bottom: 1px solid #ddd;
`;

const Td = styled.td`
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
`;

const Tr = styled.tr`
  &:nth-child(even) {
    background: #f2f2f2;
  }

  &:hover {
    background-color: #f5f5f5;
  }
`;

const Table: React.FC<TableProps> = ({ columns, data }) => {
  return (
    <TableContainer>
      <StyledTable width="100%">
        <thead>
          <tr>
            {columns.map((column, index) => (
              <Th key={index}>{column}</Th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <Tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <Td key={cellIndex}>{cell}</Td>
              ))}
            </Tr>
          ))}
        </tbody>
      </StyledTable>
    </TableContainer>
  );
};

export default Table; 